import { useState, useEffect, useContext } from 'react';
import Navbar from './pages/_components/Navbar/navbar';
import Footer from './pages/_components/footer';
import NavigationRoutes from './modules/navigation';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AppContext } from './modules/contexts/AppContexts';
import { useLocation } from 'react-router-dom';
import { Button } from 'flowbite-react';
import AuthCard from './pages/_components/Navbar/AuthCard';
import Modal from './pages/_components/Navbar/Modal';
import SurveyCard from './pages/_components/SurveyCard';
import Hotjar from '@hotjar/browser';
import { ToastContainer, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from './pages/_components/layout/Cookies';

function App() {
  const [cookiesEnabled, setCookiesEnabled] = useState(false);
  const [openAuthModal, setAuthModal] = useState(false);
  const queryClient = new QueryClient();
  const { startAuth, setStartAuth } = useContext(AppContext);
  const location = useLocation();

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted') === 'true';
    setCookiesEnabled(cookiesAccepted);

    if (cookiesAccepted) {
      initializeHotjar();
    }
  }, []);

  const initializeHotjar = () => {
    const siteId = 3858730;
    const hotjarVersion = 6;
    Hotjar.init(siteId, hotjarVersion);
  };

  const disableHotjar = () => {
    if (window.hj) {
      window.hj('trigger', 'disable');
    }
  };

  const handleCookiePreferenceChange = (accepted) => {
    setCookiesEnabled(accepted);
    if (accepted) {
      initializeHotjar();
    } else {
      disableHotjar();
    }
  };

  function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
    return null;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <div className="w-full min-h-screen flex flex-col bg-cream relative">
        <ScrollToTop />
        <Navbar />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />

        <Modal
          open={startAuth}
          overLayOpacity="sm"
          onClose={() => setStartAuth(false)}
        >
          <AuthCard closeMethod={() => setStartAuth(!startAuth)} />
        </Modal>

        <div className="flex-grow relative">
          <NavigationRoutes />
        </div>

        <Cookies onCookiePreferenceChange={handleCookiePreferenceChange} />
        <Footer />
      </div>
    </QueryClientProvider>
  );
}

export default App;
